// copied from VPC.

import { IError } from './IResponse';

export class ListResult<T> {
  public items: T;
  public index: number;
  public total: number;
  public errors?: IError[];

  constructor(items: T, index?: number, total?: number, errors?: IError[]) {
    this.items = items;
    this.index = index || 0;
    this.total = total || 0;
    this.errors = errors || [];
  }
}
